module.exports = __webpack_public_path__ + "img/custom-mark.940508ac.svg";